import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import api from '../../../api/axios';
import { IApiResponseError, IApiState } from '../../../types/api';
import { RootState } from '../..';
import { getScheduledTransfersAsync } from './getScheduledTransfersSlice';

interface IPauseScheduledTransferResponse {
  status?: boolean;
  message?: string;
  errors?: IApiResponseError[];
}

const initialState: IApiState<IPauseScheduledTransferResponse> = {
  value: null,
  status: 'idle',
  error: '',
};

export const pauseScheduledTransferAsync = createAsyncThunk(
  'scheduledTransfer/pause',
  async (id: string, { rejectWithValue, dispatch, getState }) => {
    try {
      const state = getState() as RootState;

      const accessToken = state.auth.value?.data?.token?.accessToken;

      const businessId =
        localStorage.getItem('businessId') ||
        state.auth.value?.data?.user?.businesses?.[0]?.id;

      const config = {
        headers: {
          Authorization: `Token ${accessToken}`,
          'X-Business-Id': businessId,
        },
      };

      setTimeout(() => {
        // window.location.reload();
        dispatch(getScheduledTransfersAsync());
      }, 2500);

      const { data } = await api.put<IPauseScheduledTransferResponse>(
        `/transfers/scheduled/${id}/pause`,
        {},
        config
      );

      return data;
    } catch (err) {
      const error = err as AxiosError<IPauseScheduledTransferResponse>;

      return rejectWithValue(error.response?.data);
    }
  }
);

export const scheduledTransferPauseSlice = createSlice({
  name: 'scheduledTransfer/pause',
  initialState,
  reducers: {
    resetScheduledTransferPause(state) {
      state.value = null;
      state.status = 'idle';
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(pauseScheduledTransferAsync.pending, (state) => {
        state.status = 'loading';
        state.error = '';
      })
      .addCase(pauseScheduledTransferAsync.fulfilled, (state, action) => {
        state.status = 'success';
        state.value = action.payload as IPauseScheduledTransferResponse;
      })
      .addCase(pauseScheduledTransferAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.value = action.payload as IPauseScheduledTransferResponse;
        state.error = action.error.message;
      });
  },
});

export const { resetScheduledTransferPause } =
  scheduledTransferPauseSlice.actions;

export default scheduledTransferPauseSlice.reducer;
